/**
 * Caption typography above inputs — shared by TextField, TextareaField, Select.
 */
export type FieldCaptionSize = 'sm' | 'md'

export const FIELD_CAPTION_TEXT_CLASS: Record<FieldCaptionSize, string> = {
  sm: 'text-xs leading-5 tracking-[-0.18px]',
  md: 'text-sm leading-5 tracking-[-0.21px]',
} as const
